import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

const Select = forwardRef(function Select(
  { label, hint, error, className, required, id, options = [], placeholder, children, ...rest },
  ref,
) {
  const autoId = id || `sel-${Math.random().toString(36).slice(2, 8)}`;
  // `className` dış konteynere uygulanıyor — böylece çağıran
  // `<Select className="w-auto min-w-[12rem]" />` diyerek filtre
  // toolbar'ındaki gibi genişliği sınırlayabiliyor. `cn` (clsx) tailwind
  // çakışmalarını çözmediği için, çağıran bir genişlik utility'si (w-*,
  // min-w-*, max-w-*) vermediyse varsayılan olarak `w-full` uyguluyoruz;
  // verdiyse default'u devre dışı bırakıp çağıranın değerini kullanıyoruz.
  const hasWidthClass = typeof className === 'string' && /(?:^|\s)(w-|min-w-|max-w-)/.test(className);
  return (
    <div className={cn(!hasWidthClass && 'w-full', className)}>
      {label && (
        <label htmlFor={autoId} className="block text-sm font-medium text-neutral-700 mb-1">
          {label}
          {required && <span className="text-danger-600 ml-0.5">*</span>}
        </label>
      )}
      {/*
        zuzzuu_customers SimpleSelect ile birebir hizalı:
          - 44 px yükseklik (h-11), 0.5rem radius (rounded-lg)
          - Kenarlık #CBCECD, hata durumunda #FD5995 (metin + kenarlık)
          - px-3 py-[0.69rem], text-sm font-medium
          - Focus: ring-2 ring-blue-500, border transparent
      */}
      <div className="relative">
        <select
          ref={ref}
          id={autoId}
          className={cn(
            'h-11 w-full appearance-none rounded-lg border bg-white px-3 py-[0.69rem] pr-9 text-sm font-medium outline-none transition-colors',
            'focus:ring-2 focus:ring-blue-500 focus:border-transparent',
            error
              ? 'border-[#FD5995] text-[#FD5995]'
              : 'border-[#CBCECD] text-gray-900',
            'disabled:text-gray-400',
          )}
          {...rest}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
          {children}
        </select>
        <svg
          className={cn(
            'pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4',
            error ? 'text-[#FD5995]' : 'text-gray-500',
          )}
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M5 7l5 5 5-5" />
        </svg>
      </div>
      {error && <p className="mt-1 text-xs text-[#FD5995]">{error}</p>}
      {!error && hint && <p className="mt-1 text-xs text-neutral-500">{hint}</p>}
    </div>
  );
});

export default Select;
